import examActions from "./actions";

const initialState = {
  projectDetails: [],
  heartBeat: [],
  instructions: [],
  questionsAndOptions: [],
  submitAnswer: [],
  examEvents: [],
  isSafeExamBrowser: false,
  whitelistedFolderPathWindows: "",
  whitelistedFolderPathMac: "",
  folderType: null,
  candidateScore: {
    loading: false,
    data: null,
    error: null
  },
  examSchedule:[],
  inlineUploadUrls: {},
};

const examReducer = (state = initialState, action) => {
  switch (action.type) {
    case examActions.SET_PROJECT_DETAILS:
      return {
        ...state,
        projectDetails: action.payload,
      };
    case examActions.SET_HEART_BEAT:
      return {
        ...state,
        heartBeat: action.payload
      };
    case examActions.SET_INSTRUCTIONS:
      return {
        ...state,
        instructions: action.payload
      };
    case examActions.SET_EXAM_QUESTIONS:
      return {
        ...state,
        questionsAndOptions: action.payload
      };
    case examActions.SET_SUBMIT_ANSWER:
      return {
        ...state,
        submitAnswer: action.payload
      }
    case examActions.SET_EXAM_EVENTS:
      return { ...state, examEvents: action.payload };

    case examActions.SET_CANDIDATE_SCORE_LOADING:
      return {
        ...state,
        candidateScore: {
          ...state.candidateScore,
          loading: action.payload,
        }
      };

    case examActions.SET_CANDIDATE_SCORE:
      return {
        ...state,
        candidateScore: {
          loading: false,
          data: action.payload,
          error: null
        }
      };

    case examActions.CLEAR_CANDIDATE_SCORE:
      return {
        ...state,
        candidateScore: {
          loading: false,
          data: null,
          error: null
        }
      };
      
    case examActions.SET_EXAM_SCHEDULE:
      return {
        ...state,
        examSchedule: action.payload,
      };
    case examActions.SET_SAFE_EXAM_CONFIG:
      return {
        ...state,
        isSafeExamBrowser: action.payload.isSafeExamBrowser,
        whitelistedFolderPathWindows: action.payload.whitelistedFolderPathWindows,
        whitelistedFolderPathMac: action.payload.whitelistedFolderPathMac,
        folderType: action.payload.folderType ?? null,
      };
    case examActions.SET_INLINE_UPLOAD_URL: {
      const { srNo, fileUrl } = action.payload;
      return {
        ...state,
        inlineUploadUrls: {
          ...state.inlineUploadUrls,
          [String(srNo)]: fileUrl ?? null,
        },
      };
    }
    default:
      return state;
  }
}

export default examReducer;